import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  variant?: 'light' | 'dark';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  variant = 'dark'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  const titleColor = variant === 'light' ? 'text-ivory' : 'text-navy';
  const subColor = variant === 'light' ? 'text-ivory/70' : 'text-graphite/80';
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`max-w-2xl ${isCenter ? 'mx-auto text-center' : ''}`} data-id="element-122" data-mp="gieytz3glds5">
      {eyebrow && <div className={`flex items-center gap-3 mb-4 ${isCenter ? 'justify-center' : ''}`} data-id="element-123" data-mp="uifyjb7zmf61">
          <span className="h-px w-8 bg-gold" data-id="element-124" data-mp="zbit9moi3unt" />
          <span className="text-xs font-semibold tracking-widest uppercase text-gold" data-id="element-125" data-mp="1t9ph4t2gjboe">
            {eyebrow}
          </span>
        </div>}
      <h2 className={`font-serif text-4xl md:text-5xl leading-[1.1] ${titleColor}`} data-id="element-126" data-mp="1ocfl2ukkc1rl">
        {title}
      </h2>
      {subtitle && <p className={`mt-5 text-lg leading-relaxed ${subColor}`} data-id="element-127" data-mp="231lkaijehrzh">{subtitle}</p>}
    </motion.div>;
}